import React from 'react';
import s from '../../CartItem.scss';
import {CartItemDataHook} from '../../CartItem';
import {LineItemModel} from '../../../../../../domain/models/LineItem.model';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';

export const Price = ({
  lineItem,
  shouldShowCrossedOutPriceOnLineItemLevel,
}: {
  lineItem: LineItemModel;
  shouldShowCrossedOutPriceOnLineItemLevel: boolean;
}) => {
  const {supportModifiersOnCart} = useControllerProps().cartStore;
  return (
    <div className={s.prices}>
      {!shouldShowCrossedOutPriceOnLineItemLevel && lineItem.crossedOutPrice?.formattedConvertedAmount && (
        <span
          data-hook={CartItemDataHook.ComparePrice}
          data-wix-line-full-item-price={CartItemDataHook.ComparePrice}
          className={s.comparePrice}>
          {lineItem.crossedOutPrice.formattedConvertedAmount}
        </span>
      )}
      {lineItem.price.formattedConvertedAmount && (
        <span data-hook={CartItemDataHook.Price} className={s.price} data-wix-line-item-price={CartItemDataHook.Price}>
          {supportModifiersOnCart
            ? lineItem.baseUnitPrice.formattedConvertedAmount
            : lineItem.price.formattedConvertedAmount}
        </span>
      )}
    </div>
  );
};
